import { AdvancedShippingNotice } from "../../common/AdvancedShippingNotice";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid2 as Grid,
	useMediaQuery,
} from "@mui/material";
import { Transfer } from "@/common/Transfer";
import { LargeActionLink } from "../Common/LargeActionLink";
import { MOBILE_MODAL_MEDIA_QUERY } from "./Modal.constants";
import AsnDetailsCard from "../Asn/AsnDetailsCard";

type ModalAsnDetailsProps = {
	isOpen: boolean;
	asns: AdvancedShippingNotice[];
	transfer?: Transfer;
	fromLocationId?: string;
	fromLocationName?: string;
	toLocationId?: string;
	toLocationName?: string;
	onAsnDetailsModalClose: () => void;
};

export default function ModalAsnDetails(props: ModalAsnDetailsProps) {
	const { isOpen, asns, transfer, fromLocationId, fromLocationName, toLocationId, toLocationName, onAsnDetailsModalClose } = props;
	const mobileView = useMediaQuery(MOBILE_MODAL_MEDIA_QUERY);

	return (
		<Dialog open={isOpen} onClose={onAsnDetailsModalClose} fullScreen={mobileView} maxWidth="md" fullWidth>
			<DialogTitle>{asns.length > 1 ? "ASNs" : "ASN"}</DialogTitle>
			<DialogContent>
				{asns.map((asn, index) => (
					<AsnDetailsCard
						key={asn.id}
						purchaseOrderNumber={asn.shipment.purchaseOrderId}
						invoiceNumber={asn.shipment.invoiceNumber}
						carrier={asn.shipment.carrier}
						dateShipped={asn.shipment.dateShipped}
						dateDeliveryExpected={asn.shipment.dateDeliveryExpected}
						dateDelivered={asn.shipment.dateDelivered}
						consignmentNoteNumber={asn.shipment.consignmentNoteNumber}
						consignmentTrackingUrl={asn.shipment.consignmentTrackingURL}
						consignmentStatus={asn.shipment.consignmentStatus}
						deliveryNoteNumber={asn.shipment.deliveryNoteNumber}
						totalNumberOfUnits={asn.shipment.totalNumberOfUnits}
						totalNumberOfPackages={asn.shipment.totalNumberOfPackages}
						asnType={asn.type}
						labelId={transfer?.labelId}
						fromLocationId={fromLocationId}
						fromLocationName={fromLocationName}
						toLocationId={toLocationId}
						toLocationName={toLocationName}
						isLastCard={index === asns.length - 1}
					/>
				))}
			</DialogContent>
			<DialogActions>
				<Grid container spacing={1} justifyContent="space-between" sx={{ width: '100%' }}>
					<Grid size={{ xs: 6, sm: 6 }}>
						<LargeActionLink onClick={onAsnDetailsModalClose}>Close</LargeActionLink>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
}
